// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"af51a09e","232":"69a8c4bc","365":"af51a09e","506":"af51a09e"}[chunkId] + ".chunk.css";
};